import { cn } from '@/utils/styles/cn'

/**
 * Shared lp-v3 pagination dots — the little pills in a soft grey box (used by the testimonial carousel
 * and the "magic" media stack). Active dot is a wide orange pill; the rest are small grey dots.
 */
export function LpDotsIndicator({
    count,
    activeIndex,
    onSelect,
    getLabel,
    className,
}: {
    count: number
    activeIndex: number
    onSelect?: (index: number) => void
    getLabel?: (index: number) => string
    className?: string
}) {
    return (
        <div className={cn('inline-flex items-center gap-1.5 rounded-full bg-black/[0.04] px-3 py-2', className)}>
            {Array.from({ length: count }, (_, index) => (
                <button
                    key={index}
                    type="button"
                    onClick={onSelect ? () => onSelect(index) : undefined}
                    aria-label={getLabel?.(index)}
                    aria-current={index === activeIndex}
                    className={cn(
                        'h-1.5 rounded-full transition-all',
                        index === activeIndex ? 'w-5 bg-[#FF5500]' : 'w-1.5 bg-foreground/20'
                    )}
                />
            ))}
        </div>
    )
}
